import React from "react";
import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";

// Live sessions pricing — morning group + 1:1 with the master trader
export const LiveSessions = () => {
  const scrollToForm = () => {
    document.getElementById("iscriviti")?.scrollIntoView({ behavior: "smooth" });
  };

  const items = [
    {
      id: HOME.sessionMorning,
      kicker: "Sessione · Mattutina",
      title: "Live in sala · gruppo",
      price: "€30",
      unit: "a persona",
      meta: "Minimo 10 persone per sala",
      features: [
        "Sessione live in presenza",
        "Analisi dei mercati del giorno",
        "Operatività guidata in diretta",
        "Q&A finale aperto",
      ],
    },
    {
      id: HOME.sessionOneToOne,
      kicker: "Sessione · 1 : 1",
      title: "One-to-one · Master Trader",
      price: "€150",
      unit: "a sessione",
      meta: "40 minuti · in presenza o online",
      features: [
        "Confronto diretto col Master Trader",
        "Setup personalizzato sul tuo capitale",
        "Review del tuo portfolio",
        "Piano operativo su misura",
      ],
      highlighted: true,
    },
  ];

  return (
    <section
      data-testid={HOME.sessionsSection}
      className="section-dark relative py-24 sm:py-28 px-6 border-t border-white/10"
    >
      <div className="relative mx-auto max-w-[1200px]">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="eyebrow"
          >
            In aggiunta al percorso
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.05 }}
            className="mt-5 font-display font-bold text-white leading-[0.95]"
            style={{ fontSize: "clamp(44px, 6.4vw, 92px)" }}
          >
            Sessioni live.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-5 font-body text-white/70 text-base sm:text-lg max-w-xl mx-auto leading-relaxed"
          >
            Operatività in diretta e consulenza individuale con il Master Trader.
          </motion.p>
        </div>

        {/* Two cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {items.map((it) => (
            <motion.div
              key={it.title}
              data-testid={it.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.75,
                delay: it.highlighted ? 0.15 : 0.1,
              }}
              className={`relative rounded-xl p-8 sm:p-10 transition-colors ${
                it.highlighted
                  ? "bg-white/[0.04] border border-[color:var(--lif-accent)]/35"
                  : "bg-white/[0.02] border border-white/15"
              }`}
            >
              {it.highlighted && (
                <div className="absolute top-0 right-0 bg-[color:var(--lif-accent)] text-[color:var(--lif-bg)] font-mono text-[10px] font-bold tracking-[0.24em] uppercase px-4 py-1.5 rounded-bl-xl">
                  Premium
                </div>
              )}

              <p className="eyebrow">{it.kicker}</p>
              <h3 className="mt-3 font-display font-bold text-white text-2xl sm:text-3xl">
                {it.title}
              </h3>

              <div className="mt-7 flex items-baseline gap-3">
                <span
                  className="font-display font-bold text-white leading-none"
                  style={{ fontSize: "clamp(44px, 5.4vw, 72px)" }}
                >
                  {it.price}
                </span>
                <span className="font-mono text-white/60 text-sm tracking-[0.14em] uppercase">
                  {it.unit}
                </span>
              </div>
              <p className="mt-2 font-mono text-[11px] tracking-[0.22em] uppercase text-white/50">
                {it.meta}
              </p>

              <ul className="mt-8 space-y-3">
                {it.features.map((f) => (
                  <li
                    key={f}
                    className="flex items-start gap-3 font-body text-white/80 text-sm"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      className="mt-1 flex-shrink-0 text-[color:var(--lif-accent)]"
                    >
                      <path
                        d="M2 7l3 3 7-7"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="square"
                      />
                    </svg>
                    {f}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="mt-10 sm:mt-14 text-center"
        >
          <button
            type="button"
            onClick={scrollToForm}
            className="lif-btn lif-btn-ghost"
          >
            Prenota una sessione
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default LiveSessions;
